import { React, useState, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { loadingsliceactions } from '../store/loading-slice';
import { notificationsliceactions } from '../store/notification';
import { usHttp2 } from '../custom-hooks/use-http';
import appvariables from '../appvariables';
import Button from '../components/Button';
import Table from '../components/Table';

const Errors = () => {
    const [stockerrors, setStockerrors] = useState([]);
    const [selectedStockId, setSelectedStockId] = useState('');
    const [customRate, setCustomRate] = useState('');
    const masterdispatcher = useDispatch();
    const customRateRef = useRef();

    const fetchStockErrors = () => {
        masterdispatcher(loadingsliceactions.updateloading({'state': 'loading'}));

        usHttp2(appvariables.apiurl+'stock/errors/', 'POST', {})
        .then((response) => response.json())
        .then((json) => 
        {
            masterdispatcher(loadingsliceactions.updateloading({'state': ''}));
            if(json.status === "Success")
            {
                setStockerrors(json.stocks);
            }
        })
    }

    const AddRate = (id, rate) => {
        masterdispatcher(loadingsliceactions.updateloading({'state': 'loading'}));
        usHttp2(appvariables.apiurl + 'stock/addrate/', 'POST',{id: id, rate: rate})
        .then((response) => response.json())
        .then((json) => {
          if(json['status'] == 'Success')
          {
            let kkk = [...stockerrors];
            for(let i=0; i<stockerrors.length; i++)
            {
              if(stockerrors[i].id == id)
              {
                kkk.splice(i, 1);
                break;
              }
            }
            setStockerrors(kkk);
            // Clear custom rate inputs after successful rate addition
            setSelectedStockId('');
            setCustomRate('');
            if (customRateRef.current) {
                customRateRef.current.value = '';
            }
            masterdispatcher(notificationsliceactions.updatenotification({'message': json.message, 'status': json.status}));
          } else {
            masterdispatcher(notificationsliceactions.updatenotification({'message': json.message, 'status': json.status}));
          }
            masterdispatcher(loadingsliceactions.updateloading({'state': ''}));
        })
    }

    const addCustomRate = () => {
        if (!selectedStockId || !customRate || parseFloat(customRate) <= 0) {
            masterdispatcher(notificationsliceactions.updatenotification({'message': 'Please select a stock and enter a valid rate', 'status': 'Error'}));
            return;
        }
        AddRate(selectedStockId, parseFloat(customRate));
    }

    const createButtons = (mrates) => {
        return (
            <>
            {mrates.map((mrate, index) => {
                return <Button cs={{padding: '4px 8px'}} clickhandler={() => {
                    AddRate(mrate.id, mrate.rate);
                }} >{mrate.rate}</Button>
            } )}
            </>
        )
    }

    const tablefields = [
        {'name': 'Id', 'key': 'id', cs: {width: '10px'}},
        {'name': 'Name', 'key': 'name'},
        {'name': 'Package', 'key': 'package'},
        {'name': 'Company', 'key': 'company'},
        {'name': 'Price', 'key': 'price'},
        {'name': 'Details', 'key': 'details'},
        {'name': 'Matched Rates', 'key': 'rates', transformer: createButtons }
    ]

    return(
        <>
            <h2>Errors</h2>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }} >
                <h3>Stock Errors</h3>
                <Button cs={{ cursor: 'pointer'}} clickhandler={fetchStockErrors} >Get Stock Errors</Button>
            </div>
            
            {/* Custom Rate Input Row */}
            {stockerrors.length > 0 && (
                <div style={{ 
                    marginTop: '20px', 
                    padding: '15px', 
                    border: '1px solid #ccc', 
                    borderRadius: '5px',
                    backgroundColor: '#f9f9f9' 
                }}>
                    <h4>Add Custom Rate</h4>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px', flexWrap: 'wrap' }}>
                        <div>
                            <label>Select Stock:</label>
                            <select 
                                value={selectedStockId} 
                                onChange={(e) => setSelectedStockId(e.target.value)}
                                style={{ 
                                    marginLeft: '10px', 
                                    padding: '5px 10px', 
                                    border: '1px solid #ccc',
                                    borderRadius: '4px',
                                    minWidth: '200px'
                                }}
                            >
                                <option value="">Select a stock...</option>
                                {stockerrors.map((stock) => (
                                    <option key={stock.id} value={stock.id}>
                                        {stock.name} - {stock.package} - {stock.company} (₹{stock.price})
                                    </option>
                                ))}
                            </select>
                        </div>
                        <div>
                            <label>Rate:</label>
                            <input
                                ref={customRateRef}
                                type="number"
                                placeholder="Enter rate"
                                value={customRate}
                                onChange={(e) => setCustomRate(e.target.value)}
                                style={{
                                    marginLeft: '10px',
                                    padding: '5px 10px',
                                    border: '1px solid #ccc',
                                    borderRadius: '4px',
                                    width: '120px'
                                }}
                            />
                        </div>
                        <Button 
                            cs={{ padding: '8px 16px' }} 
                            clickhandler={addCustomRate}
                        >
                            Add Rate
                        </Button>
                    </div>
                </div>
            )}
            <Table data={stockerrors} tablefields={tablefields} />
        </>
    )
}

export default Errors;